import React, { useCallback, useRef } from "react";
import Button from "../../../form/Button";

const SectionTable2 = ({
  data,
  setFilters,
  timelineLoading,
  scholarshipData,
}) => {
  const observer = useRef();

  const loadMoreRef = useCallback(
    (node) => {
      if (timelineLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && scholarshipData?.metaData?.nextPage) {
          setFilters((prev) => ({
            ...prev,
            page: prev.page + 1,
          }));
        }
      });

      if (node) observer.current.observe(node);
    },
    [timelineLoading]
  );

  return (
    <>
      <div className="space-y-6">
        {data?.title && (
          <h4 className="text-3xl font-semibold text-center text-chestnut-rose">
            {data?.title}
          </h4>
        )}
        {data?.subdata?.length > 0 && (
          <div className="w-full max-h-[calc(16rem+2px)] overflow-auto scrollbar border border-shades-05">
            <table className="border-collapse w-full">
              <thead className="sticky top-0 bg-white z-[1]">
                <tr className="border-b border-shades-05">
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-xl xls:text-2xl font-CanelaDeck gap-2 items-center">
                      Title
                    </div>
                  </th>
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-2xl font-CanelaDeck gap-2 items-center">
                      Open Date
                    </div>
                  </th>
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-2xl font-CanelaDeck gap-2 items-center">
                      Close date
                    </div>
                  </th>
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-2xl font-CanelaDeck gap-2 items-center">
                      Actions
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.subdata?.map((item, index) => (
                  <tr
                    key={index}
                    className="border-b border-shades-05 last:border-b-0"
                  >
                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center font-CanelaDeck text-xl">
                        {item?.title}
                      </div>
                    </td>
                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center font-CanelaDeck text-xl">
                        {item?.startDate}
                      </div>
                    </td>
                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center font-CanelaDeck text-xl text-chestnut-rose">
                        {item?.endDate}
                      </div>
                    </td>
                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center font-CanelaDeck text-xl">
                        {item?.viewAction && (
                          <Button
                            buttonHasLink={item?.viewAction?.isLink}
                            buttonFunction={
                              item?.viewAction?.isLink
                                ? () => {}
                                : item?.viewAction?.onClick
                            }
                            buttonLabel={item?.viewAction?.label}
                            buttonClasses={`!h-10 !bg-transparent !px-0 !text-chestnut-rose ${
                              item?.viewAction?.label === "View Details"
                                ? "cursor-pointer"
                                : "cursor-default"
                            }`}
                            buttonLabelClasses={"!text-xl !font-CanelaDeck"}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tbody>
                <tr>
                  <td colSpan={4}>
                    <div ref={loadMoreRef} className="h-6" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default SectionTable2;
